// Pure asset helpers: given a logo slug, return URL / srcset / monogram.
// Make->slug resolution lives in @workspace/listing-requirements (the
// car_makes-backed registry) and is wired through artifact-local wrappers.

export interface CarLogoAssets {
  fallback: string;
  webpSrcSet: string;
}

export function buildLogoAssets(slug: string, basePath: string): CarLogoAssets {
  const base = basePath.replace(/\/$/, "");
  return {
    fallback: `${base}/${slug}.png`,
    webpSrcSet: [
      `${base}/64/${slug}.webp 64w`,
      `${base}/128/${slug}.webp 128w`,
      `${base}/256/${slug}.webp 256w`,
    ].join(", "),
  };
}

export function buildLogoUrl(slug: string, basePath: string): string {
  return `${basePath.replace(/\/$/, "")}/${slug}.png`;
}

export function carLogoMonogram(make: string | null | undefined): string {
  if (!make) return "?";
  const norm = make.trim();
  if (!norm) return "?";
  return norm.charAt(0).toUpperCase();
}
